module.exports = __webpack_public_path__ + "img/hoergertshausen.e09638f4.jpg";